<template>
  <div class="plan-view">
    <div v-if="product">
      <v-card class="my-4">
        <v-card-title class="font-weight-bold">
          Abonnement
        </v-card-title>
        <v-card-text>
          Ihr aktuelles Abonnement: <strong>{{ product.name }}</strong
          >.
          <span v-if="subscription_period_end && subscription_period_end_is_in_future">
            Die nächste Zahlung ist am {{ subscription_period_end | moment("DD.MM.YYYY") }} fällig.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-xs-left">
            <v-btn text v-on:click="change_plan()">Abo ändern</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </div>
    <!--<v-btn @click="get_subscription()">Get subscription</v-btn>-->
  </div>
</template>

<script>
const FALLBACK_PLAN = "soda-free-v1";

import moment from "moment";

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

export default {
  name: "PlanView",
  mounted() {
    this.get_subscription();
  },
  computed: {
    user_info() {
      return this.$store.state.originalStore.user_info;
    },
  },
  watch: {
    user_info(oldUserInfo, newUserInfo) {
      this.get_subscription();
    },
  },
  methods: {
    get_subscription() {
      if (!this.user_info) {
        return;
      }
      //console.log('user_info', this.user_info)
      var product_id = this.get_user_attribute("active_product_id");
      if (!product_id) {
        console.error(
          "no subscription plan. on user_prop should we set one automatically here? sure but let us test subscription process a little more."
        );
        this.product = products[FALLBACK_PLAN];
      } else {
        this.product = products[product_id];
      }
      if (this.product.paid === false) {
        // we are on a free plan
      } else {
        // we are on a paid plan
        this.subscription_period_end = this.get_user_attribute("d24_valid_to_ts");
        this.subscription_period_end_is_in_future = moment() < moment(this.subscription_period_end);
      }
    },
    get_user_attribute(key) {
      return this.user_info.attributes["custom:" + key];
    },
    change_plan() {
      this.$router.push({ path: "/home/plans" });
    },
  },
  data: function() {
    return {
      logged_in: null,
      displayError: false,
      subscription: null,
      product: null,
      subscription_period_end: null,
      subscription_period_end_is_in_future: null,
    };
  },
};
</script>

<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem
  align:center
</style>
